import Vue from 'vue';
import * as html from './404.html';

export default Vue.extend({
	render: html.render,
	staticRenderFns: html.staticRenderFns,

	components: {
		'gpal-footer': () => import('../../checkout/ui/components/footer')
	},

	methods: {
		onGoBack: function ()
		{
			window.history.back();
		}
	}
});
